function onBedrockSignInUser(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onBedrockSignInUser', e);
  }

  return window.dispatchEvent(new CustomEvent('onzephrunmountalloutcomes'));
}

export default onBedrockSignInUser;
